<template>
  <v-card class="d-flex flex-column align-center justify-center pa-5">
    <v-card-title class="mb-5">Νέα Κεφάλαιο</v-card-title>
    <v-form @submit.prevent class="form d-flex flex-column justify-center">
      <v-row>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Όνομα"
            v-model="mmfNationalName"
            class="rounded text-body-1 font-weight-regular"
            :error-messages="mmfNationalNameErrors"
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <v-text-field
            label="Όνομα GLEIF"
            v-model="mmfGLEIFName"
            class="rounded text-body-1 font-weight-regular"
            :error-messages="mmfGLEIFNameErrors"
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <v-text-field
            label="Κωδικός"
            v-model="mmfNationalCode"
            class="rounded text-body-1 font-weight-regular"
            :error-messages="mmfNationalCodeErrors"
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <v-text-field
            label="Χώρα"
            v-model="mmfCompetentAuthorityCountry"
            class="rounded text-body-1 font-weight-regular"
            :error-messages="mmfCompetentAuthorityCountryErrors"
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <v-text-field
            label="LEI"
            v-model="mmfLEI"
            class="rounded text-body-1 font-weight-regular"
            :error-messages="mmfLEIErrors"
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <v-text-field
            label="Αρμόδια Αρχή"
            v-model="mmfCompetentAuthority"
            class="rounded text-body-1 font-weight-regular"
            :error-messages="mmfCompetentAuthorityErrors"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            label="Έδρα"
            v-model="mmfDomicile"
            class="rounded text-body-1 font-weight-regular"
            :error-messages="mmfDomicileErrors"
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <v-text-field
            label="Τύπος"
            v-model="mmfType"
            class="rounded text-body-1 font-weight-regular"
            :error-messages="mmfTypeErrors"
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <v-text-field
            label="Νομικό Πλαίσιο"
            v-model="mmfLegalFramework"
            class="rounded text-body-1 font-weight-regular"
            :error-messages="mmfLegalFrameworkErrors"
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <v-text-field
            label="ISIN"
            v-model="mmfISINReportedFromCA"
            class="rounded text-body-1 font-weight-regular"
            :error-messages="mmfISINReportedFromCAErrors"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="6">
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFormatted"
                label="Ημερομηνία έναρξης εξουσιοδότησης"
                v-bind="attrs"
                @blur="date = parseDate(dateFormatted)"
                v-on="on"
                :error-messages="dateErrors"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              @input="menu1 = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <div class="d-flex justify-center">
        <v-btn
          type="submit"
          class="success rounded text-sm-body-1 font-weight-regular mr-5"
          :loading="loader"
          @click="onSubmit"
        >
          <span>Προσθήκη</span>
        </v-btn>
        <v-btn
          class="secondary rounded text-sm-body-1 font-weight-regular"
          @click="$emit('closeDialog')"
        >
          <span>Επιστροφή</span>
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>
  
  <script>
import axios from "axios";
import { mapState } from "vuex";
import { required } from "vuelidate/lib/validators";
export default {
  props: {
    currentCreditInstitute: Object,
  },

  data() {
    return {
      menu1: false,
      mmfNationalCode: null,
      mmfLEI: null,
      mmfCompetentAuthorityCountry: null,
      mmfNationalName: null,
      mmfGLEIFName: null,
      mmfCompetentAuthority: null,
      mmfDomicile: null,
      mmfType: null,
      mmfLegalFramework: null,
      mmfISINReportedFromCA: null,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateFormatted: this.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      ),

      loader: false,
    };
  },

  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
  },

  validations: {
    mmfNationalCode: { required },
    mmfLEI: { required },
    mmfCompetentAuthorityCountry: { required },
    mmfNationalName: { required },
    mmfGLEIFName: { required },
    mmfCompetentAuthority: { required },
    mmfDomicile: { required },
    mmfType: { required },
    mmfLegalFramework: { required },
    mmfISINReportedFromCA: { required },
    date: { required },
  },

  computed: {
    ...mapState({
      creditInstitutes: (state) => state.creditInstitutes.creditInstitutes,
    }),

    mmfNationalCodeErrors() {
      const errors = [];
      if (!this.$v.mmfNationalCode.$dirty) return errors;
      if (!this.$v.mmfNationalCode.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    mmfLEIErrors() {
      const errors = [];
      if (!this.$v.mmfLEI.$dirty) return errors;
      if (!this.$v.mmfLEI.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    mmfCompetentAuthorityCountryErrors() {
      const errors = [];
      if (!this.$v.mmfCompetentAuthorityCountry.$dirty) return errors;
      if (!this.$v.mmfCompetentAuthorityCountry.required)
        errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    mmfNationalNameErrors() {
      const errors = [];
      if (!this.$v.mmfNationalName.$dirty) return errors;
      if (!this.$v.mmfNationalName.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    mmfGLEIFNameErrors() {
      const errors = [];
      if (!this.$v.mmfGLEIFName.$dirty) return errors;
      if (!this.$v.mmfGLEIFName.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    mmfCompetentAuthorityErrors() {
      const errors = [];
      if (!this.$v.mmfCompetentAuthority.$dirty) return errors;
      if (!this.$v.mmfCompetentAuthority.required)
        errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    mmfDomicileErrors() {
      const errors = [];
      if (!this.$v.mmfDomicile.$dirty) return errors;
      if (!this.$v.mmfDomicile.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    mmfTypeErrors() {
      const errors = [];
      if (!this.$v.mmfType.$dirty) return errors;
      if (!this.$v.mmfType.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    mmfLegalFrameworkErrors() {
      const errors = [];
      if (!this.$v.mmfLegalFramework.$dirty) return errors;
      if (!this.$v.mmfLegalFramework.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    mmfISINReportedFromCAErrors() {
      const errors = [];
      if (!this.$v.mmfISINReportedFromCA.$dirty) return errors;
      if (!this.$v.mmfISINReportedFromCA.required)
        errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    dateErrors() {
      const errors = [];
      if (!this.$v.date.$dirty) return errors;
      if (!this.$v.date.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
  },

  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${day.padStart(2, "0")}-${month.padStart(2, "0")}`;
    },

    async onSubmit() {
      try {
        this.$v.$touch();
        if (this.$v.$invalid) return;
        this.loader = true;
        await axios.post(`${process.env.VUE_APP_BASE_URL}/admin/AddFund`, {
          mmfNationalCode: this.mmfNationalCode,
          mmfLEI: this.mmfLEI,
          mmfCompetentAuthorityCountry: this.mmfCompetentAuthorityCountry,
          mmfNationalName: this.mmfNationalName,
          mmfGLEIFName: this.mmfGLEIFName,
          mmfCompetentAuthority: this.mmfCompetentAuthority,
          mmfDomicile: this.mmfDomicile,
          mmfType: this.mmfType,
          mmfLegalFramework: this.mmfLegalFramework,
          mmfISINReportedFromCA: this.mmfISINReportedFromCA,
          authorisationStartDate: this.date,
          creditInstituteId: this.currentCreditInstitute.creditInstituteId,
        });
        this.loader = false;

        this.$store.commit("toggleSnackbar", {
          open: true,
          color: "success",
          text: "Η προσθήκη κεφαλαίου ολοκληρώθηκε με επιτυχία!",
        });
        await this.$emit("getCreditInstitutes");

        this.$emit("closeDialog");
      } catch (e) {
        console.log(e);
        this.loader = false;
      }
    },
  },
};
</script>
  
  <style>
</style>